export class ExchangeRateData{
    constructor(){}
    Code : string;
    CodeName : string;
    Date : Date;
    BuyingRate : number;
    MiddleRate : number;
    SellingRate : number;

    Deserialize(input : any){
        this.Code = input.Code;
        this.CodeName = input.CodeName;
        this.Date = input.Date;
        this.BuyingRate = input.BuyingRate;
        this.MiddleRate = input.MiddleRate;
        this.SellingRate = input.SellingRate;
        return this;

    }
}